require('src/creative/core-page/editorial-review-carousel/editorial-review-carousel.scss');
var stringUtils = require('src/interlock/no-ui/utils/string/string');
var dependedOnViewportAd = require('src/interlock/product/ads/ad-manager/depended-on-viewport-ad');
var gptSlotIniter = require('src/interlock/product/ads/ad-manager/gpt-slot-initer');



function _initDOM() {
    var _editorialDrawer = $('#editorial-review-drawer'),
        editorialCarouselOwl = $('.editorial-review-carousel-container .owl-carousel');

    function ctaClickHandler(e) {
        var $ele = $(e.target);
        var anchor = $ele.data('targetDiv');
        var $modalContentTarget = $($ele.data('target') + ' .modal-content');
        if (anchor && anchor.length > 0) {
            _editorialDrawer.one('shown.bs.modal', function() {
                var collapsibleEle = $('#' + anchor + ' .panel-collapse');
                if (collapsibleEle) {
                    collapsibleEle.addClass('in');
                    collapsibleEle.attr('aria-expanded', true);
                    collapsibleEle.css('height', 'auto');
                }
                var anchorPosition = $('#' + anchor).position();
                if(anchorPosition) {
                    $modalContentTarget.scrollTop(anchorPosition.top);
                }
            });
        }
        e.preventDefault();
    }

    var CTAbtns = $('.editorial-cta.btn');
    $.each(CTAbtns, function() {
        $(this).on('click', ctaClickHandler);
    });

    $(editorialCarouselOwl).on('translate.owl.carousel', function(e) {
        var $slide = $(e.target)
            .find('.owl-item')
            .eq(e.item.index);
        dependedOnViewportAd.setSlotIniter(gptSlotIniter);
        dependedOnViewportAd.carouselSlideViewportAdsInView($slide);
    });
    
    function getStyleId(ele) {
        return ele.dataset['styleId'];
    }

    function dedupeBasicArray(arr) {
        var newMap = arr.reduce(function(prev, cur){
            prev[cur] = true;
            return prev;
        }, {});
        return Object.getOwnPropertyNames(newMap);
    }

    var similarVehiclesEles = $('.similar-vehicle[data-style-id]');
    var styleIdsWithDupes = Array.prototype.map.call(similarVehiclesEles, getStyleId);
    var styleIds = dedupeBasicArray(styleIdsWithDupes);
    var styleMSRPMap = {};
    if (styleIds.length) {
        $.ajax({
            type: 'GET',
            url: '/api/vehicle/v3/styles?id='+ styleIds.join(',') +'&fields=id,price(baseMSRP)',
            success: function(data) {
                data.results.forEach(function(obj) {
                    styleMSRPMap[obj.id] = stringUtils.formatAsUsPrice(obj.price.baseMSRP, 'N/A');
                });

                $.each(similarVehiclesEles, function(a, ele) {
                    ele.innerText = styleMSRPMap[ele.dataset.styleId];
                });
            },
            error: function() {
                $.each(similarVehiclesEles, function(a, ele) {
                    ele.innerText = '';
                });
            }
        });
    }

}

(function() {
    _initDOM();
})();
module.exports = _initDOM;



//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/editorial-review-carousel/editorial-review-carousel.js
// module id = 172
// module chunks = 1 6 28